import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrEscrowSpPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_escrow_sp'
        title='Escrow and special terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'escrow', subNavType: 'escrow', subNavPage: 'escrow_sp' }}
      />
    )
  }
}

export default MasterLoanAgrEscrowSpPageSF
